import { Location } from "@angular/common";
import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDialog } from "@angular/material/dialog";
import { ObservedAuctionDTO } from "@shared/model/auction.model";
import { ApiService } from "@shared/services/api.service";
import { MqttService } from "@shared/services/mqtt/mqtt.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Component({
	selector: "app-live-full",
	templateUrl: "./live-full.component.html",
	styleUrl: "./live-full.component.scss",
	standalone: false
})
export class LiveFullComponent implements OnInit, OnDestroy {
	/** Potential MQTT connection error dialog content */
	@ViewChild('connectError') connectError;
	/** Keeps track of whether we showed the connection error dialog */
	private warningShown = false;
	protected closeTemplateModal = () => { };

	serverTime: number; // timestamp
	leasysObservedAuctions: ObservedAuctionDTO[];
	observedAuctions: ObservedAuctionDTO[];
	// flagAnimation = false;
	destroyed = false;
	reconnectEmitter = new EventEmitter<void>();
	constructor(
		private mqttService: MqttService,
		public utils: ClickarUtilsService,
		private _location: Location,
		private dialog: MatDialog,
		private apiService: ApiService
	) {
		this.mqttService.disconnected()
			.pipe(takeUntilDestroyed())
			.subscribe(() => {
				console.log("mqtt disconnected");
				if (!this.destroyed) {
					if (!this.warningShown) {
						this.warningShown = true;
						const dialogRef = this.dialog.open(this.connectError, { maxWidth: 400 })
						this.closeTemplateModal = () => {
							dialogRef.close();
							this.closeTemplateModal = () => { };
						};
					}
					console.log("mqtt reconnect");
					this.mqttService.connect().subscribe(() => {
						this.reconnectEmitter.emit();
					});
				}
			});
	}

	protected trimAuction = (auctions: ObservedAuctionDTO[], auction: ObservedAuctionDTO) => {
		const index = auctions.indexOf(auction);
		if (index !== -1) {
			auctions.splice(index, 1);
		}
	};

	ngOnInit() {
		this.apiService.getTimeUsingGET().subscribe(value => {
			this.serverTime = value;
		});

		this.mqttService.connect(true).subscribe(() => {
			this.apiService
				.getObservedAuctionsLotsUsingGET()
				.subscribe(value => {
					value.sort((a, b) =>
						a.auctionDTO.endDate < b.auctionDTO.endDate
							? -1
							: a.auctionDTO.endDate > b.auctionDTO.endDate
								? 1
								: 0
					);
					this.observedAuctions = [];
					this.leasysObservedAuctions = [];
					for (const a of value) {
						this[a.auctionDTO.auctionType === "LEA" ? "leasysObservedAuctions" : "observedAuctions"].push(a);
					}
				});
		});
	}

	ngOnDestroy(): void {
		this.destroyed = true;
		this.mqttService.disconnect();
		// this.timeObservable.unsubscribe();
	}

	goBack() {
		this._location.back();
	}
}